export type doorType = {
    id: number;
    name: string;
    isLocked: boolean;
}
export interface allFloorsType {
    floor: number;
    doors: doorType[];
}

export type GarageType = {
    id: number;
    name: string;
    isOpened: boolean;
}

export type GateType = {
    id: number;
    name: string;
    isOpened: boolean;
}



// dummy data to play aroud 

export const AllFloors: allFloorsType[] = [
    {
        floor: 1,
        doors: [
            { id: 1, name: "backdoor", isLocked: true },
            { id: 2, name: "backroom", isLocked: false },
            { id: 3, name: "entrance", isLocked: false },
            { id: 4, name: "bathroom", isLocked: true },
        ]
    },
    {
        floor: 2,
        doors: [
            { id: 5, name: "backdoor", isLocked: true },
            { id: 6, name: "backroom", isLocked: false },
            { id: 7, name: "entrance", isLocked: false },
            { id: 8, name: "bathroom", isLocked: true },
        ]
    }
]
export const GaragesData: GarageType[] = [
    { id: 1, name: "Garage 1", isOpened: true },
    { id: 2, name: "Garage 2", isOpened: false }
]
export const GatesData: GateType[] = [
    { id: 1, name: "front gate", isOpened: true },
    { id: 2, name: "back gate ", isOpened: false }
]